import { render, staticRenderFns } from "./EdipartsOverview.vue?vue&type=template&id=a49625ba&scoped=true&"
import script from "./EdipartsOverview.vue?vue&type=script&lang=js&"
export * from "./EdipartsOverview.vue?vue&type=script&lang=js&"
import style0 from "./EdipartsOverview.vue?vue&type=style&index=0&id=a49625ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a49625ba",
  null
  
)

/* custom blocks */
import block0 from "./EdipartsOverview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports